import { Audio, Images } from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class PopupChain extends Phaser.GameObjects.Container {
  static get NEXT_DIALOG() {return 'NEXT_DIALOG';}

  constructor(scene, spriteArray, soundArray) {
    super(scene);
    this.sprite = null;
    this.soundFile = null;
    this.currentIndex = 0;
    this.soundChannel = Audio.createSound(this.scene, 1, false, 0, Audio.LOCALIZATION_AUDIO_SPRITE);

    this.spriteArray = spriteArray;
    this.soundArray = soundArray;

    this.sprite = Images.addImage(0, 0, spriteArray[this.currentIndex], this);

    this.scene.time.addEvent({ delay: 500, callback: () => this.playSound() });

    this.sprite.on('pointerdown', () => {this.doClick();});
    this.once(Phaser.GameObjects.Events.DESTROY, () => {
      this.soundChannel.removeAllListeners();
      this.soundChannel.destroy();
    });
  };

  showNext() {

    this.currentIndex++;

    const spriteName = this.spriteArray[this.currentIndex];
    if (spriteName) {
      this.sprite.setFrame(spriteName);
    }
    else this.sprite.destroy();

    this.playSound();
  }

  doClick() {
    this.emit(PopupChain.NEXT_DIALOG, this.currentIndex);

    Audio.playOneShot('click', this.scene);

    this.showNext();
  };

  playSound() {

    if (this.soundChannel.isPlaying) {
      this.soundChannel.removeListener('complete');
    }

    const soundName = this.soundArray[this.currentIndex];

    if (soundName) {

      this.soundChannel.play(soundName);
      this.soundChannel.once('complete', this.soundDone, this);
    }
  }

  soundDone() {

    const value = this.currentIndex;

    this.emit('NEXT_DIALOG', value);

    this.scene.time.addEvent({ delay: 500, callback: () => this.showNext() });
  }
}